<template>
    <div>
        <EditWarehouse />
    </div>
</template>

<script>
import EditWarehouse from '@/components/warehouse/EditWarehouse.vue';
export default {
    components: {
        EditWarehouse
    },
    name: 'WarehouseEdit'
}
</script>